// apps/spa/src/routes/ReminderNew.tsx
// /reminders/new — wraps <ReminderEditorForm mode='new' /> with a sensible
// default preset (Daily 09:00 ET) + BASTN_GOLD color hex. The fallback in
// ReminderEditorForm itself uses the same defaults; passing them here keeps
// the route's intent explicit.

import { Link } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { ReminderEditorForm } from '@/components/reminders/ReminderEditorForm';

export function ReminderNew() {
  return (
    <div className="space-y-4">
      <Link
        to="/reminders"
        className="text-muted-foreground hover:text-foreground inline-flex items-center text-sm transition-colors"
      >
        <ChevronLeft className="size-4" />
        Back to reminders
      </Link>
      <ReminderEditorForm mode="new" />
    </div>
  );
}
